import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top';

import Login from './features/login';
import GoogleCallback from './features/googleCallback';
import Home from './features/home';
import PreIngestion from './features/preIngestion';
import Register from './features/register';
import Help from './features/help';
import SearchManualFile from './features/searchManualFile';
import HomeManualFile from './features/homeManualFile';
import ApprovalManualFile from './features/approvalManualFile';
import IntegrationLayer from './features/integrationLayer';
import RegisterUser from './features/registerUser';
import ResetPasswordUser from './features/resetPasswordUser';
import RegisterManualFile from './features/registerManualFile';
import UploadManualFile from './features/uploadManualFile';
import RegisterSystemIL from './features/registerSystemIL';
import SearchEntityIL from './features/searchEntityIL';

import StoreProvider from './components/storage/provider';
import RoutesPrivate from './components/privateRouter/private';

export default function Routes(props) {

  return (
    <BrowserRouter>
      <StoreProvider>
        <ScrollToTop>
          <Switch>
            <Route path="/login" exact component={Login} />
            <Route path="/login/auth/callback" exact component={GoogleCallback} />
            <Route path="/faq" exact component={Help} />
            <Route path="/cadastro-novo-usuario" exact component={RegisterUser} />
            <Route path="/cadastro-nova-senha" exact component={ResetPasswordUser} />
            <RoutesPrivate path="/" exact component={Home} />
            <RoutesPrivate path="/cadastro-arq-manual" exact component={HomeManualFile} />
            <RoutesPrivate path="/cadastro-arq-manual/cadastrar" exact component={RegisterManualFile} />
            <RoutesPrivate path="/cadastro-arq-manual/upload" exact component={UploadManualFile} />
            <RoutesPrivate path="/cadastro-arq-manual/homologar" exact component={ApprovalManualFile} />
            <RoutesPrivate path="/cadastro-arq-manual/consultar" exact component={SearchManualFile} />
            <RoutesPrivate path="/pre-ingestion" exact component={PreIngestion} />
            <RoutesPrivate path="/register" exact component={Register} />
            <RoutesPrivate path="/integration-layer" exact component={IntegrationLayer} />
            <RoutesPrivate path="/integration-layer/entidade/cadastrar" exact component={SearchEntityIL} />
            <RoutesPrivate path="/integration-layer/sistema/cadastrar" exact component={RegisterSystemIL} />
          </Switch>
        </ScrollToTop>
      </StoreProvider>
    </BrowserRouter>
  )
}
